import { ReactNode } from 'react'

import { Nullable } from '@types'

import { SxProps, Theme } from '@mui/material'
import Popover, { PopoverOrigin } from '@mui/material/Popover'

export interface CustomPopoverProps {
  id: string
  anchor: Nullable<HTMLElement>
  setAnchor: (value: Nullable<HTMLElement>) => void
  onClose?: () => void
  children: ReactNode
  anchorOrigin?: PopoverOrigin
  transformOrigin?: PopoverOrigin
  sx?: SxProps<Theme>
}

const CustomPopover = (props: CustomPopoverProps) => {
  const { anchor, setAnchor, children, id, anchorOrigin, transformOrigin, sx, onClose } = props

  return (
    <Popover
      id={anchor ? id : undefined}
      open={!!anchor}
      anchorEl={anchor}
      onClose={() => {
        setAnchor(null)
        onClose?.()
      }}
      anchorOrigin={
        anchorOrigin || {
          vertical: 'bottom',
          horizontal: 'left',
        }
      }
      elevation={3}
      transformOrigin={
        transformOrigin || {
          vertical: 'top',
          horizontal: 'left',
        }
      }
      sx={
        sx || {
          padding: '20px',
          marginTop: '10px',
        }
      }
    >
      {children}
    </Popover>
  )
}

export default CustomPopover
